// CANONICAL COPY (GH #7115). src/constants/obligations/obl-cra-vulnerability-handling-process.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-cra-vulnerability-handling-process',
  title:
    'Operate a vulnerability handling process for products with digital elements throughout the support period',
  description:
    'Confirm that the manufacturer operates a vulnerability handling process meeting the requirements of CRA Annex I, Part II throughout the declared support period (CRA Art. 13(6)): identify and document component vulnerabilities (§1); address and remediate without delay, with security updates issued separately from functional updates where technically feasible (§2); apply effective and regular cybersecurity testing and reviews (§3); after a security update is available, share and publicly disclose information about the fixed vulnerability (§4 — including description, CVE id, severity and remediation guidance). Review the vulnerability handling procedure, test cadence, and disclosure log.',
  category: 'technical',
  scfIds: ['SCF-OPS-004', 'SCF-AUD-003', 'SCF-DEV-005'],
  cadence: { frequency: '3m', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Vulnerability handling procedure is published' },
    { type: 'document-approved', description: 'Procedure has been approved' },
    { type: 'document-within-sla', description: 'Procedure review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
